export const impersonationCookieName = 'impersonate_user_id';
